// @flow
import { v4 as uuidv4 } from 'uuid';
import { makeActionCreator, reduce } from '../helpers/utils';

const SHOW = 'snackbar/show';
const HIDE = 'snackbar/hide';

export const hideSnackbar = makeActionCreator(HIDE);
export const showSnackbar = (message: string) => ({
  type: SHOW,
  payload: {
    id: uuidv4(),
    message
  }
});

export type State = {
  message: string,
  id: string
};

export const initialState: State = {
  message: '',
  id: ''
};

export default reduce<State, any>(initialState, {
  [SHOW]: (state: State, action) => ({
    ...initialState,
    message: action.payload.message,
    id: action.payload.id
  }),
  [HIDE]: (state: State) => ({
    ...state,
    ...initialState
  })
});
